import type { Root } from 'react-dom/client';
import { monterDepuisEnvironnement } from './app/entree.js';
import { enregistrerServiceWorker } from './pwa/enregistrer.js';

/**
 * Point d'entrée de la PWA (RFC-050, RFC-L50-002 refaite à la main) : la coquille de L50 (routeur par rôle, layouts, hôte BETA).
 * Données d'exemple seulement en développement avec VITE_LAKOU_MOCKS=1 ; un build de production vise toujours la vraie API.
 */
export function monter(element: HTMLElement): Root {
  return monterDepuisEnvironnement(element, import.meta.env);
}

const cible = typeof document !== 'undefined' ? document.getElementById('racine') : null;
if (cible) {
  monter(cible);
  // Service worker de L22 : enregistré après le chargement pour ne pas concurrencer l'affichage (production seulement).
  window.addEventListener('load', () => void enregistrerServiceWorker());
}
